export default {
  mainPage: 'Main Page',
  additionalInformationAdded: 'Additional information added',
  assignOrSelectTheNameFromTheList: 'Assign or select the name from the list',
  AddPeopleToAnExistingList: 'Add people to an existing list',
  updateList: 'Update list',
  eventModified: 'Event modified',
  completeTheRequiredFields: 'Complete the required fields',
  anErrorHasOcurred: 'An error has ocurred',
  insertKeybeUiOnYourWebsite: 'Insert Keybe UI on your website',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: ' To insert KeybeUI into your website, you must create a DIV element with the ID \'keybe\' in the body of your site',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: 'And then add the following Script in the Footer of your site',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: 'To add elements in the DOM to open the KeybeUI, you can use a script similar to the following',
  selectProfilePhoto: 'Select profile photo',
  selectPhoto: 'Select Photo',
  photoSuccessfullyUpdated: 'Photo successfully updated',
  select: 'Select'
}
